import QuotationTopbarInfo from "./QuotationTopbarInfo";

export default QuotationTopbarInfo;



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationTopbarInfo/index.js